import lmsAPI from "./lmsAPI";

class SEOTemplatesService {
  async index() {
    const res = await lmsAPI.get("/seo_templates");
    return res.data;
  }

  async update(SEOTemplateParams) {
    const res = await lmsAPI.put(`/seo_templates/update`, {
      seo_templates_params: SEOTemplateParams,
    });
    return res.data;
  }

  async updateLocaleAware(updates, locale) {
    const res = await lmsAPI.put(`/seo_templates/update`, {
      locale: locale,
      locale_updates: updates,
    });
    return res.data;
  }
}

export default new SEOTemplatesService();
